import { render, staticRenderFns } from "./Max.vue?vue&type=template&id=0b66d259&scoped=true"
import script from "./Max.vue?vue&type=script&lang=js"
export * from "./Max.vue?vue&type=script&lang=js"
import style0 from "./Max.vue?vue&type=style&index=0&id=0b66d259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66d259",
  null
  
)

export default component.exports